// Use VITE_* env variables from .env.development as single source of truth
const {
  VITE_ENV,
  VITE_API_URL,
  VITE_BASE_URL,
  VITE_IDENTITY_SERVICE_API,
  VITE_DIFFUSION_SERVICE_API,
  VITE_NOTIFICATION_SERVICE_API,
  VITE_DOCUMENT_SERVICE_API,
  VITE_ANALYTICS_SERVICE_API,
  VITE_TRACEABILITY_SERVICE_API,
  VITE_COMPLIANCE_SERVICE_API,
  VITE_LIVELIHOOD_SERVICE_API,
  VITE_MAPBOX_TOKEN,
} = import.meta.env;

const config = {
  apiUrl: VITE_API_URL,
  baseUrl: VITE_BASE_URL,
  env: VITE_ENV,
  identityServiceApi: VITE_IDENTITY_SERVICE_API,
  diffusionServiceApi: VITE_DIFFUSION_SERVICE_API,
  notificationServiceApi: VITE_NOTIFICATION_SERVICE_API,
  documentServiceApi: VITE_DOCUMENT_SERVICE_API,
  analyticsServiceApi: VITE_ANALYTICS_SERVICE_API,
  traceabilityServiceApi: VITE_TRACEABILITY_SERVICE_API,
  complianceServiceApi: VITE_COMPLIANCE_SERVICE_API,
  livelihoodServiceApi: VITE_LIVELIHOOD_SERVICE_API,
  mapboxToken: VITE_MAPBOX_TOKEN,
};

export default config;
